import React from 'react'
import { Redirect, Route, Switch } from 'react-router-dom'
import { MainContainer } from '../../../components/Layout/MainContainer'
import { MainMenu } from '../../../components/Layout/MainMenu'
import { useCurrentLocale } from '../../../data/remote/Language'
import { useRoutes } from '../../../data/remote/RouteData'
import { useSettings } from '../../../data/remote/Settings'
import { useAuthentication } from '../../../data/remote/User'
import { Error404 } from '../../LoggedIn/Error404'
import { Loading } from '../../LoggedIn/Loading'
import routeComponents from '../../routeComponents'

const MainNavigator: React.FC = () => {
  const { loading: settingsLoading } = useSettings()
  const { loading: routesLoading, routes } = useRoutes()
  const { loggingIn: userLoading, loggedIn } = useAuthentication() // Add loggedIn check
  const locale = useCurrentLocale()

  // If not logged in, redirect to login page
  if (!loggedIn && !userLoading) {
    return <Redirect to={`/${locale}/login`} />
  }

  const menuVisible = !!routes.main.length
  const contentVisible = !(settingsLoading || routesLoading || userLoading)

  return (
    <MainContainer>
      {menuVisible && <MainMenu />}
      {contentVisible ? (
        <Switch>
          {routes.any.map((route, index) => {
            const Component = routeComponents[route.component]
            if (!Component) {
              return null
            }
            return (
              <Route key={index} path={route.path}>
                <Component navigatorType={loggedIn ? 'main' : 'login'} />{' '}
                {/* Pass correct navigatorType based on auth status */}
              </Route>
            )
          })}
          {routes.main[0] &&
            loggedIn /* Only redirect to main routes if logged in */ &&
            [`/${locale}`, '/'].map((path) => (
              <Route key={path} path={path} exact>
                <Redirect to={routes.main[0]?.href} />
              </Route>
            ))}
          <Route path="*">
            <Error404 />
          </Route>
        </Switch>
      ) : (
        <Loading />
      )}
    </MainContainer>
  )
}

export default MainNavigator
